export default __webpack_public_path__ + "static/media/logoheader.d48f46fe.svg";